<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ isEdit ? 'Edit room' : 'Add room' }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form" id="room-form" (ngSubmit)="submit()">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Room number</span>
        <input type="text" class="text-box-active" formControlName="roomNumber" />
      </div>
      <div class="field">
        <span class="field-label">Floor</span>
        <input type="text" class="text-box-active" formControlName="floor" />
      </div>
      <div class="field">
        <span class="field-label">Capacity</span>
        <input type="number" class="text-box-active" formControlName="capacity" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Room type</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="roomType"
          >
            @for(t of roomTypes; track t){
            <mat-option [value]="t">{{ t }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <span class="field-label">Gender</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="gender"
          >
            @for(g of genders; track g){
            <mat-option [value]="g">{{ g }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="submit" form="room-form" class="ac-primary-btn" [disabled]="isLoading">
      {{ isEdit ? 'Save' : 'Add' }}
    </button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
